import { render } from "./component-kazn-divider.vue?vue&type=template&id=9b8dd8fa"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-kazn-divider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b8dd8fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b8dd8fa', __exports__)) {
    api.reload('9b8dd8fa', __exports__)
  }
  
  module.hot.accept("./component-kazn-divider.vue?vue&type=template&id=9b8dd8fa", () => {
    api.rerender('9b8dd8fa', render)
  })

}


export default __exports__